import Cookies from "js-cookie";
import { get, post, getApiBase } from "./ApiService";
import { TOKEN_COOKIE } from "./constants";

const ATTACHMENTS_ENDPOINT = "/attachments";

// Bir bug'a ya da yoruma ait ekleri getirir.
export const getAttachments = async ({ bugId, commentId } = {}) => {
  const params = {};
  if (bugId) params.bug_id = bugId;
  if (commentId) params.comment_id = commentId;

  const response = await get(ATTACHMENTS_ENDPOINT, params);
  return Array.isArray(response?.attachments) ? response.attachments : [];
};

// Yüklenmiş bir dosya URL'sini bug'a veya yoruma ek olarak kaydeder.
export const addAttachment = async ({ bugId, commentId, filePath, uploadedBy } = {}) =>
  post(ATTACHMENTS_ENDPOINT, {
    bug_id: bugId,
    comment_id: commentId,
    file_path: filePath,
    uploaded_by: uploadedBy,
  });

// attachments.php DELETE'i form-encoded gövde bekler (parse_str) — CommentService.removeComment ile aynı desen.
export const deleteAttachment = async (attachmentId) => {
  const id = String(attachmentId || "").trim();
  if (!id) throw new Error("attachment_id gerekli.");

  const body = new URLSearchParams();
  body.set("attachment_id", id);

  const token = Cookies.get(TOKEN_COOKIE);
  if (token) body.set("token", token);

  const response = await fetch(`${getApiBase()}${ATTACHMENTS_ENDPOINT}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Accept: "application/json",
    },
    body: body.toString(),
  });

  const payload = await response.json().catch(() => ({
    status: "error",
    message: "Ek silinemedi.",
  }));

  if (!response.ok || payload?.status === "error") {
    throw new Error(payload?.message || "Ek silinemedi.");
  }

  return payload;
};
